import {Month} from '@planning/model/enum';

export class MonthHelper {
  public static sortMonths(months: Month[]): Month[] {
    let newMonths: Month[] = [];

    for (let month of months) {
      switch (month) {
        case Month.JANUARY:
          newMonths[0] = month;
          break;
        case Month.FEBRUARY:
          newMonths[1] = month;
          break;
        case Month.MARCH:
          newMonths[2] = month;
          break;
        case Month.APRIL:
          newMonths[3] = month;
          break;
        case Month.MAY:
          newMonths[4] = month;
          break;
        case Month.JUNE:
          newMonths[5] = month;
          break;
        case Month.JULY:
          newMonths[6] = month;
          break;
        case Month.AUGUST:
          newMonths[7] = month;
          break;
        case Month.SEPTEMBER:
          newMonths[8] = month;
          break;
        case Month.OCTOBER:
          newMonths[9] = month;
          break;
        case Month.NOVEMBER:
          newMonths[10] = month;
          break;
        case Month.DECEMBER:
          newMonths[11] = month;
          break;
      }
    }

    return newMonths.flat();
  }

  public static getMonthName(monthNb: number): Month {
    let monthName = Month.JANUARY;
    switch (monthNb) {
      case 1 :
        monthName = Month.JANUARY;
        break;
      case 2 :
        monthName = Month.FEBRUARY;
        break;
      case 3 :
        monthName = Month.MARCH;
        break;
      case 4 :
        monthName = Month.APRIL;
        break;
      case 5 :
        monthName = Month.MAY;
        break;
      case 6 :
        monthName = Month.JUNE;
        break;
      case 7 :
        monthName = Month.JULY;
        break;
      case 8 :
        monthName = Month.AUGUST;
        break;
      case 9 :
        monthName = Month.SEPTEMBER;
        break;
      case 10 :
        monthName = Month.OCTOBER;
        break;
      case 11 :
        monthName = Month.NOVEMBER;
        break;
      case 12 :
        monthName = Month.DECEMBER;
        break;
    }
    return monthName;
  }

  public static getLastDayMonth(monthNb: number, year: number): number {
    return new Date(year, monthNb, 0).getDate();
  }

  public static getAllDaysOfMonth(monthNb: number, year: number): Date[] {
    let date = new Date(year, monthNb, 1);
    const dates: Date[] = [];
    let i = 0;
    while (date.getMonth() === monthNb) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
      i++;
    }

    return dates;
  }
}
